import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon, Button } from 'semantic-ui-react';

// @ts-ignore
import DatePagination from 'components/DatePagination';

import {
    DATE_FILTER_TYPE,
    SPRAY_EVENTS_NAMESPACE
} from 'services/sprayEvents/constants';

import { deleteQueryString } from 'services/router/actions';

import { AppState } from 'services/types';

import { FERTILIZER_DATE_FILTER_TYPE } from 'services/fertilizerEvents/constants';
import { selectFilterType } from './selectors';
import EventsSearch from '../EventsSearch';

export interface Props {
    namespace?: string;
}

const EventsCurrentFilter = (props: Props): React.ReactElement => {
    const { namespace } = props;
    const dispatch = useDispatch();
    const filterType = useSelector((state: AppState) =>
        selectFilterType(state, props)
    );

    const getDateFilterType = () =>
        namespace === SPRAY_EVENTS_NAMESPACE
            ? DATE_FILTER_TYPE
            : FERTILIZER_DATE_FILTER_TYPE;

    const [isFiltering, setIsFiltering] = useState(
        filterType !== getDateFilterType()
    );

    // to handle filter when sector filter changing
    useEffect(() => {
        if (filterType === getDateFilterType() && isFiltering) {
            setIsFiltering(false);
        }
    }, [filterType]);

    const toggleFilter = () => {
        if (isFiltering) dispatch(deleteQueryString());

        setIsFiltering(!isFiltering);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {!isFiltering && <DatePagination />}
            {isFiltering && <EventsSearch namespace={namespace} />}
            <Button icon compact onClick={toggleFilter}>
                <Icon name={isFiltering ? 'arrow left' : 'search'} />
            </Button>
        </div>
    );
};

EventsCurrentFilter.defaultProps = {
    namespace: SPRAY_EVENTS_NAMESPACE
};

export default EventsCurrentFilter;
